<div class="panel" [class.active]="toggle.checked">
  <app-form-switch
    labelPosition="before"
    [inline]="true"
    [formControl]="form.get('status')"
    [matTooltip]="customTooltip || getTooltip()"
    [disabled]="(isEditing$ | async) || disabled"
    #toggle
  >
    {{ label }}
  </app-form-switch>
  <div class="row" *ngIf="toggle.checked && viewType !== 'table'">
    <div class="col-md-6" *ngIf="filterByCategories">
      <mat-form-field2 class="mat-block">
        <mat-label i18n>Select Categories</mat-label>
        <app-select
          [items]="categories"
          bindValue="value"
          bindLabel="label"
          [formControl]="form.get('categories')"
          [multiple]="true"
          placeholder="Apply to all categories"
          i18n-placeholder
          i18n-matTooltip
          matTooltip="Select the categories you want to send the notification"
          [disabled]="isEditing$ | async"
        >
        </app-select>
      </mat-form-field2>
    </div>
    <div class="col-md-3" *ngIf="lateBookings">
      <mat-checkbox
        [formControl]="form.get('late_bookings')"
        [disabled]="isEditing$ | async"
        class="mt-2"
        matTooltip="Enable this checkbox if trigger should be fired for a booking which is confirmed/created after the rental checkin time is passed"
        >Run for Late Bookings</mat-checkbox
      >
    </div>
  </div>
</div>

<app-autopilot-automation-info
  #info
  [automationGroup]="automationGroup"
  [event]="event"
  [eventSourceType]="eventSourceType"
  [class.d-none]="viewType !== 'table'"
></app-autopilot-automation-info>
